import React from "react";
import {
  Form,
  Flex,
  theme,
} from "antd";
import { HeaderApp } from "../../shared";
import { useCreateClient } from "../hooks/useCreateClient";
import type { ClientData } from "../types";
import openNotification from "../../../utils/openNotification";
import { useNavigate } from "react-router-dom";
import ClientForm from "../components/ClientForm";

const NewClient: React.FC = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const { mutate: createClientMutation, isPending: isCreating } = useCreateClient();
  const navigate = useNavigate();

  const handleFinish = async (values: ClientData) => {
    createClientMutation(values, {
      onSuccess: () => {
        form.resetFields();
        navigate('/catalogo/clientes');
        openNotification('success', 'Cliente creado exitosamente');
      },
      onError: (error) => {
        openNotification('error', 'Error', error.message);
      }
    });
  };

  return (
    <Flex
      vertical
      style={{
        background: token.colorBgLayout,
      }}
    >
      <HeaderApp sectionName="Agregar Nuevo Cliente" showBack />

      <Flex
        vertical
        gap={28}
        style={{
          maxWidth: 640,
          width: "100%",
          margin: "0 auto",
          padding: "28px 24px 100px",
        }}
      >
        <ClientForm
          form={form}
          onFinish={handleFinish}
          isPending={isCreating}
          buttonText="Guardar Cliente"
          formId="new-client-form"
        />
      </Flex>
    </Flex>
  );
};

export default NewClient;
